import taxRatesSlice from './taxRatesSlice';

export * from './thunks';

export default taxRatesSlice;
